<template>
  <div class="admin-login-log">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="操作日志" name="oper"></el-tab-pane>
        <el-tab-pane label="登录日志" name="login"></el-tab-pane>
      </el-tabs>

      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input
              v-model="searchUsername"
              :placeholder="activeTab === 'oper' ? '操作账号' : '登录账号'"
              prefix-icon="el-icon-search"
              clearable
              class="filter-input"
              @keyup.enter.native="handleSearch"
            />
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              class="filter-daterange"
              @change="handleSearch"
            />
            <date-range-quick v-model="dateRange" @change="handleSearch" />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table
        :key="activeTab"
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        row-key="id"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column
          prop="username"
          :label="activeTab === 'oper' ? '操作人' : '登录账号'"
          min-width="110"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="activeTab === 'oper'"
          prop="module"
          label="模块"
          width="120"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="activeTab === 'oper'"
          prop="action"
          label="操作"
          min-width="320"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="activeTab === 'login'"
          prop="loginIp"
          label="登录IP"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="activeTab === 'login'"
          prop="loginLocation"
          label="登录地点"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          :label="activeTab === 'oper' ? '时间' : '登录时间'"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatTime(scope.row.loginTime) }}
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!error && !loading && list.length === 0" class="empty-state">
        <el-empty :description="activeTab === 'oper' ? '暂无操作日志' : '暂无登录日志'" />
      </div>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http.js'
import { getDefaultDateRange } from '@/utils/dateRange'
import DateRangeQuick from '@/components/DateRangeQuick.vue'

export default {
  name: 'AdminLoginLog',
  components: { DateRangeQuick },
  data() {
    return {
      activeTab: 'oper',
      list: [],
      loading: false,
      error: '',
      searchUsername: '',
      dateRange: getDefaultDateRange(),
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatTime(val) {
      if (!val) return '-'
      return String(val).replace('T', ' ')
    },
    normalizeRow(row) {
      if (!row || typeof row !== 'object') return row
      return {
        ...row,
        loginIp: row.loginIp || row.login_ip || '-',
        loginLocation: row.loginLocation || row.login_location || '未知',
        loginTime: row.loginTime || row.login_time || ''
      }
    },
    handleTabClick(tab) {
      if (tab && tab.name) {
        this.activeTab = tab.name
      }
      this.pagination.page = 1
      this.$nextTick(() => this.fetchList())
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          logType: this.activeTab === 'oper' ? 1 : 0
        }
        if (this.searchUsername) params.username = this.searchUsername.trim()
        const [start, end] = this.dateRange || []
        if (start) params.startTime = start
        if (end) params.endTime = end

        const result = await get('/admin/login-log/page', params)
        const data = result.data || {}
        const records = Array.isArray(data.records)
          ? data.records
          : (Array.isArray(data.list) ? data.list : [])
        this.list = records.map(this.normalizeRow)
        this.pagination.total = Number(data.total || 0)
        if (data.page) this.pagination.page = Number(data.page)
        if (data.pageSize) this.pagination.pageSize = Number(data.pageSize)
      } catch (e) {
        this.list = []
        this.pagination.total = 0
        this.error = (e && e.message) || '获取系统日志失败'
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.searchUsername = ''
      this.dateRange = getDefaultDateRange()
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.filter-input {
  width: 180px;
}
.filter-daterange {
  width: 380px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
.empty-state {
  padding: 24px 0;
}
</style>
